<template src="./template.html"></template>

<script>
import TENKENGYOUMU_DETAIL from 'src/consts/tenkengyoumu_detail'
import masterMixin from 'src/mixins/masterMixin'
import notificationMixin from 'src/mixins/notificationMixin'
import tenkenDataBaseApi from 'src/apis/tenken_data_base'
import tenkenDataDetailApi from 'src/apis/tenken_data_rojou'

export default {
  displayPageName: '詳細結果',
  data() {
    return {
      search: {},

      tdb: {},
      tdds: [],

      deleteCandidate: {},
      showDeleteModal: false,

      tenkenStaffCands: [],
      rosenCands: [],
      tenkengyoumuDetailCands: [],

      rosenHoukouMap: {},
      tenkenKubunMap: {},
      hasonjoukyouMap: {},

      pagination: {
        currentPage: 1,
        itemsPerPage: 50,
      },

      isRequesting: false,
    }
  },
  computed: {
    paginatedList() {
      const nextPageIdx = this.pagination.currentPage * this.pagination.itemsPerPage
      const minIdx = nextPageIdx - this.pagination.itemsPerPage
      return this.tdds.filter((e, i) => {
        return i >= minIdx && i < nextPageIdx
      })
    },
    hasList() {
      return this.tdds.length > 0
    },
  },
  async mounted() {
    const promises = [
      this.ensureUserAndMasters(),
      this.getTenkenDataBase()
    ]
    await Promise.all(promises)
    this.prepareMasters()
    this.prepareSearchParams()
    this.doSearch()
  },
  mixins: [masterMixin, notificationMixin],
  methods: {
    async getTenkenDataBase() {
      const { data } = await tenkenDataBaseApi.show(this.$route.params.base_id)
      this.tdb = data
    },
    prepareMasters() {
      const master = window.master
      // 点検員
      this.tenkenStaffCands = master.staff.vals
      // 路線
      this.rosenCands = master.rosen.vals
      // 対象(点検業務詳細)
      this.tenkengyoumuDetailCands = master.tenkengyoumu_detail.vals.filter(e => {
        const detailGyoumuId = parseInt(e.m_tenkengyoumu_detail_id)
        return (detailGyoumuId === TENKENGYOUMU_DETAIL.DOBOKU) ||
          (detailGyoumuId === TENKENGYOUMU_DETAIL.SHISETSU_DENKI)
      })

      // 方向, 点検区分, 破損状況表示用
      this.rosenHoukouMap = master.rosen_houkou.vals.reduce((acc, e) => {
        acc[e.uniq_id] = e; return acc
      }, {})
      this.tenkenKubunMap = master.tenken_kubun.vals.reduce((acc, e) => {
        acc[e.uniq_id] = e; return acc
      }, {})
      this.hasonjoukyouMap = master.hasonjoukyou.vals.reduce((acc, e) => {
        acc[e.uniq_id] = e; return acc
      }, {})
    },
    prepareSearchParams() {
      const search = {}
      // 対象(点検業務詳細)
      if (this.tenkengyoumuDetailCands.length > 0) {
        search.detailGyoumuId =
          this.tenkengyoumuDetailCands[0].m_tenkengyoumu_detail_id
      }
      this.search = search
    },
    resetSearchResults() {
      this.tdds = []
      this.pagination.currentPage = 1
    },
    async doSearch() {
      this.isRequesting = true
      this.resetSearchResults()
      try {
        const reqObj = {
          base_id: this.tdb.base_id,
          detail_gyoumu_id: this.search.detailGyoumuId,
        }
        const { data } = await tenkenDataDetailApi.index(reqObj)
        this.tdds = data
        this.isRequesting = false
      } catch (err) {
        console.error('error', err)
        this.isRequesting = false
      }
    },
    openDeleteModal(tdd) {
      this.deleteCandidate = tdd
      this.showDeleteModal = true
    },
    closeDeleteModal() {
      this.deleteCandidate = {}
      this.showDeleteModal = false
    },
    async deleteTenkenDataDetail() {
      this.isRequesting = true
      try {
        await tenkenDataDetailApi.delete(this.deleteCandidate.detail_id)
        await this.doSearch()
        this.closeDeleteModal()
        this.notifySuccess1('点検結果詳細を削除しました。')
        this.isRequesting = false
      } catch (err) {
        const msg = '点検結果詳細の削除に失敗しました。' +
          '管理者にご連絡ください。'
        this.notifyError1(msg, { err })
        this.isRequesting = false
      }
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
